import api from '../common/helpers/apiHelper';
import { clearStorage } from '../common/helpers/storageHelper';
import { IUser } from '../common/models/user/IUser';
import { auth } from '../common/helpers/authHelper';
import { env } from '../env';
import * as Sentry from '@sentry/react';
import LogRocket from 'logrocket';

export const getCurrentUser = async () => {
  const user = await api.get<IUser>('/api/auth/me');
  const { id, firstName, lastName, workspace, email } = user;
  const name = `${firstName} ${lastName}`;
  if (heap.identity !== id) {
    heap.identify(id);
    heap.addUserProperties({ name, workspace: workspace.name });
  }

  window.Beacon('init', env.beacon.id);
  LogRocket.identify(id, {
    name,
    email,
    company: workspace.name
  });
  LogRocket.getSessionURL(sessionURL => {
    window.Beacon('identify', {
      name,
      email,
      company: workspace.name,
      signature: user.helpScoutSignature,
      sessionURL
    });
    Sentry.setContext('LogRocket', { sessionURL });
  });

  Sentry.setUser({ id, workspace: workspace.name });

  return user;
};

export const logout = async () => {
  clearStorage();
  heap.resetIdentity();
  Sentry.setUser(null);
  auth.logout({ returnTo: window.location.origin });
};
